import { render, staticRenderFns } from "./WxForm.vue?vue&type=template&id=73804766&scoped=true"
import script from "./WxForm.vue?vue&type=script&lang=js"
export * from "./WxForm.vue?vue&type=script&lang=js"
import style0 from "./WxForm.vue?vue&type=style&index=0&id=73804766&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73804766",
  null
  
)

export default component.exports